// type/type-map へのアクセサを段階的にlibへ集約
import pokemonTypeMap, { type DamageRelations } from '../type/type-map';
import { type PokemonType, POKEMON_TYPE_STERA } from '../types/type';
export { type_id_to_hiraganakatakana } from '../type/type-map';

type PokemonTypeRelationKey = keyof typeof pokemonTypeMap;

// ステラタイプや未定義キーに対する安全な空データ
const EMPTY_RELATIONS: DamageRelations = {
  double_damage_from: [],
  double_damage_to: [],
  half_damage_from: [],
  half_damage_to: [],
  no_damage_from: [],
  no_damage_to: [],
};

function isPokemonTypeRelationKey(pokemonType: PokemonType): pokemonType is PokemonTypeRelationKey {
  // ステラは相性表に存在しないため除外する
  return pokemonType !== POKEMON_TYPE_STERA;
}

export function getDamageRelations(defenseType: PokemonType): DamageRelations {
  if (!isPokemonTypeRelationKey(defenseType)) {
    return EMPTY_RELATIONS;
  }
  const relation = pokemonTypeMap[defenseType];
  return relation?.damage_relations ?? EMPTY_RELATIONS;
}
